import React from "react";

// MUI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AttachmentIcon from "@mui/icons-material/Attachment";

import { useAppSelector, useAppDispatch } from "../../redux/hooks/redux-hooks";
import { getAbbreviation, displayDateFormart } from "../../utility/utils";
import { getProjectDocument } from "../../redux/actions/ProjectActions";

const WinLossHistory = () => {
  const dispatch = useAppDispatch();

  const projectBidStatusHistory = useAppSelector(
    (state) => state.winloss.bidStatusHistory
  );

  const handleDocumentClick = (docId: number) => {
    dispatch(getProjectDocument(docId, "bidStatus"));
  };

  const renderStatusHistory = projectBidStatusHistory.map((history) => (
    <ListItem alignItems="flex-start" key={history.id} disableGutters>
      <ListItemAvatar>
        <Avatar>{getAbbreviation(history.userName)}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Stack direction="row" gap={2} alignItems="center" component="span">
            <Typography variant="subtitle2" component="span">
              {history.userName}
            </Typography>
            <Typography variant="caption" component="span">
              {displayDateFormart(history.date)}
            </Typography>
          </Stack>
        }
        secondary={
          <Stack direction="row" gap={1} alignItems="center" component="span">
            <Typography variant="subtitle2" component="span">
              {history.bidStatus}
            </Typography>
            {history.attachment && (
              <IconButton
                size="small"
                color="primary"
                aria-label="attachment"
                onClick={() => handleDocumentClick(history.id)}
              >
                <AttachmentIcon fontSize="small" />
              </IconButton>
            )}

            <Typography variant="body2" component="span">
              {" "}
              - {history.remarks}
            </Typography>
          </Stack>
        }
      />
    </ListItem>
  ));

  return (
    <Box>
      <List>{renderStatusHistory}</List>
    </Box>
  );
};

export default WinLossHistory;
